<div class="st-page">
  <a class="st-back-link" (click)="goBack()"><i class="ri-arrow-left-line"></i> {{ 'backToClass' | translate }}</a>

  <div class="st-page-head">
    <div>
      <h1 class="st-title">{{ selectedDateObj | date: 'EEEE' }}</h1>
    </div>
    <p-calendar [(ngModel)]="selectedDateObj" [ngModelOptions]="{standalone: true}" inputId="period-attendance-date"
      styleClass="scd-calendar" dateFormat="dd MMM yy" [maxDate]="maxDate" [showIcon]="true" appendTo="body"
      (onSelect)="onDateChange()"></p-calendar>
  </div>

  <div class="pwa-period-list" *ngIf="loading">
    <div class="st-card pwa-skeleton-card" *ngFor="let s of skeletonPlaceholders"></div>
  </div>

  <div class="st-empty-state" *ngIf="!loading && loadError">
    <i class="ri-error-warning-line"></i> {{ 'couldNotLoadPeriodsTryAgain' | translate }}
  </div>

  <div class="st-empty-state" *ngIf="!loading && !loadError && hasNoPeriods">
    <i class="ri-calendar-line"></i> {{ 'noClassScheduledForThisDate' | translate }}
  </div>

  <ng-container *ngIf="!loading && !loadError && !hasNoPeriods">
    <!-- ---------- Ongoing (no section header, tappable) ---------- -->
    <div class="pwa-period-list" *ngIf="onGoingPeriods.length">
      <div class="st-card pwa-period-card" *ngFor="let p of onGoingPeriods" (click)="openPeriod(p)">
        <div class="pwa-card-row pwa-card-row-top">
          <span class="pwa-period-subject">{{ subjectLabel(p) | translate }}</span>
          <span class="pwa-period-status">{{ 'ongoing' | translate }}</span>
        </div>
        <div class="pwa-card-row pwa-card-row-duration">
          {{ 'durationLabel' | translate }}: {{ durationLabel(p) | translate }}
        </div>
        <div class="pwa-card-row pwa-teacher-row">
          <div class="pwa-teacher-avatar" [class.pwa-teacher-avatar-empty]="!p.staffImage">
            <img *ngIf="p.staffImage" [src]="p.staffImage" alt="" />
          </div>
          <span>{{ teacherNameLabel(p) | translate }}</span>
        </div>
        <div class="pwa-card-row pwa-card-row-bottom">
          <span class="pwa-period-time pwa-period-time-ongoing" *ngIf="hasTimeRange(p)">
            {{ p.periodStartTime }} - {{ p.periodEndTime }}
          </span>
          <span class="pwa-period-time pwa-period-time-ongoing" *ngIf="!hasTimeRange(p)">
            {{ 'notScheduled' | translate }}
          </span>
          <span class="pwa-tap-status">{{ statusLabel(p) | translate }}</span>
        </div>
      </div>
    </div>

    <!-- ---------- Upcoming (section header, NOT tappable) ---------- -->
    <ng-container *ngIf="upcomingPeriods.length">
      <div class="pwa-section-divider"><span>{{ 'upcoming' | translate }}</span></div>
      <div class="pwa-period-list">
        <div class="st-card pwa-period-card pwa-period-disabled" *ngFor="let p of upcomingPeriods">
          <div class="pwa-card-row pwa-card-row-top">
            <span class="pwa-period-subject">{{ subjectLabel(p) | translate }}</span>
          </div>
          <div class="pwa-card-row pwa-card-row-duration">
            {{ 'durationLabel' | translate }}: {{ durationLabel(p) | translate }}
          </div>
          <div class="pwa-card-row pwa-teacher-row">
            <div class="pwa-teacher-avatar" [class.pwa-teacher-avatar-empty]="!p.staffImage">
              <img *ngIf="p.staffImage" [src]="p.staffImage" alt="" />
            </div>
            <span>{{ teacherNameLabel(p) | translate }}</span>
          </div>
          <div class="pwa-card-row pwa-card-row-bottom">
            <span class="pwa-period-time" *ngIf="hasTimeRange(p)">{{ p.periodStartTime }} - {{ p.periodEndTime }}</span>
            <span class="pwa-period-time" *ngIf="!hasTimeRange(p)">{{ 'notScheduled' | translate }}</span>
            <!-- Always "Tap to mark" even though upcoming cards have no
                 click handler at all — matches the spec's documented
                 (misleading) mobile-app behaviour exactly. -->
            <span class="pwa-tap-status">{{ 'tapToMark' | translate }}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- ---------- Completed (section header, tappable) ---------- -->
    <ng-container *ngIf="completedPeriods.length">
      <div class="pwa-section-divider"><span>{{ 'completed' | translate }}</span></div>
      <div class="pwa-period-list">
        <div class="st-card pwa-period-card" *ngFor="let p of completedPeriods" (click)="openPeriod(p)">
          <div class="pwa-card-row pwa-card-row-top">
            <span class="pwa-period-subject">{{ subjectLabel(p) | translate }}</span>
            <span class="pwa-period-status">{{ 'completed' | translate }}</span>
          </div>
          <div class="pwa-card-row pwa-card-row-duration">
            {{ 'durationLabel' | translate }}: {{ durationLabel(p) | translate }}
          </div>
          <div class="pwa-card-row pwa-teacher-row">
            <div class="pwa-teacher-avatar" [class.pwa-teacher-avatar-empty]="!p.staffImage">
              <img *ngIf="p.staffImage" [src]="p.staffImage" alt="" />
            </div>
            <span>{{ teacherNameLabel(p) | translate }}</span>
          </div>
          <div class="pwa-card-row pwa-card-row-bottom">
            <span class="pwa-period-time" *ngIf="hasTimeRange(p)">{{ p.periodStartTime }} - {{ p.periodEndTime }}</span>
            <span class="pwa-period-time" *ngIf="!hasTimeRange(p)">{{ 'notScheduled' | translate }}</span>
            <span class="pwa-tap-status">{{ statusLabel(p) | translate }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
